import { InvoiceReportResponseDTO } from '@/models/back-office-pages/invoices'
import {
  AdministrationTypes,
  AutoReportDTO,
  FromToFilterInput,
  Page_AutoReportDTO,
  ReportPeriod,
  ReportStatus,
  ReportType,
} from '@/models/common'
import { Direction } from '@/models/table'

export enum AccountingNoteReportStatus {
  PENDING = 'PENDING',
  READY = 'READY',
  ERROR = 'ERROR',
  CANCELED = 'CANCELED',
}

export interface AccountingNoteReportDTO {
  documentId: string
  fileName: string
  createdOn: Date
  status: AccountingNoteReportStatus
  uploader: string
  content: string
}

interface Page_AccountingNoteReportDTO {
  content: AccountingNoteReportDTO[]
  number: number
  size: number
  totalElements: number
  totalPages: number
}

export interface NotesReportsData {
  listAccountingNoteReports: Page_AccountingNoteReportDTO
}

export interface NotesReportsVariables {
  pageSize?: number
  pageNum?: number
  sortDirection?: Direction
  sortField?: string
}

export interface DownloadNotesReportData {
  downloadGeneratedAccountingNoteReport: AccountingNoteReportDTO
}

export interface DownloadNotesReportVariables {
  documentId: string
}

export interface CancelReportData {
  cancelReport: InvoiceReportResponseDTO
}

export interface CancelReportVariables {
  reportId: string
  reportType: ReportType
}

export interface SystemReportsData {
  listAutoReports: Page_AutoReportDTO
}

export interface SystemReportsVariables {
  createdOn?: FromToFilterInput
  sourcingAgentAdministrates?: AdministrationTypes[]
  reportPeriod?: ReportPeriod[]
  reportType?: ReportType[]
  pageSize?: number
  pageNum?: number
  sortDirection?: Direction
  sortField?: string
}

export interface DownloadSystemReportData {
  downloadAutoGeneratedReport: AutoReportDTO
}

export interface DownloadSystemReportVariables {
  documentId: string
  reportType: ReportType
}

export enum SystemReportType {
  INVOICE = 'INVOICE',
  ACCOUNTING_NOTE = 'ACCOUNTING_NOTE',
  ACCOUNTING_RECONCILIATION = 'ACCOUNTING_RECONCILIATION',
}

export interface AccountingNoteReportResponseDTO {}

export interface GenerateNotesReportData {
  requestAccountingNotesReport: AccountingNoteReportResponseDTO
}

export interface GenerateReportVariables {
  period: FromToFilterInput
  sourcingAgentAdministrates: AdministrationTypes
}

export enum GenerateReportFieldNames {
  PERIOD = 'period',
  SOURCING_AGENT_ADMINISTRATES = 'sourcingAgentAdministrates',
}

export interface GenerateReportActionBarProps {
  onClose?: () => void
  resetTable: () => void
}

export interface GenerateVATReportData {
  requestAccountingVatReport: string
}

export interface AccountingVatReportDTO {
  documentId: string
  fileName: string
  createdOn: Date
  status: ReportStatus
  uploader: string
  content: string
}

interface Page_AccountingVatReportDTO {
  content: AccountingVatReportDTO[]
  number: number
  size: number
  totalElements: number
  totalPages: number
}

export interface VATReportsData {
  listAccountingVatReports: Page_AccountingVatReportDTO
}

export interface VATReportsVariables {
  pageSize?: number
  pageNum?: number
  sortDirection?: Direction
  sortField?: string
}

export interface DownloadVATReportData {
  downloadAccountingVatReport: AccountingVatReportDTO
}

export interface DownloadVATReportVariables {
  documentId: string
}

export interface CancelVATReportData {
  cancelAccountingVatReport: boolean
}

export interface CancelVATReportVariables {
  reportId: string
}

export interface AccountingReconciliationReportDTO {
  documentId: string
  fileName: string
  createdOn: Date
  status: AccountingNoteReportStatus
  uploader: string
  content: string
}

interface Page_AccountingReconciliationReportDTO {
  content: AccountingReconciliationReportDTO[]
  number: number
  size: number
  totalElements: number
  totalPages: number
}

export interface ReconciliationsReportsData {
  listAccountingReconciliationReports: Page_AccountingReconciliationReportDTO
}

export interface ReconciliationsReportsVariables {
  pageSize?: number
  pageNum?: number
  sortDirection?: Direction
  sortField?: string
}

export interface DownloadReconciliationsReportData {
  downloadGeneratedAccountingReconciliationReport: AccountingReconciliationReportDTO
}

export interface DownloadReconciliationsReportVariables {
  documentId: string
}

export interface AccountingReconciliationReportResponseDTO {
  reportId: string
}

export interface GenerateReconciliationsReportData {
  requestAccountingReconciliationReport: AccountingReconciliationReportResponseDTO
}

export interface GenerateReconciliationsReportVariables {
  period: FromToFilterInput
  bankAccountId: string
}

export interface GenerateReconciliationsReportFormValues {
  period: FromToFilterInput
  bankAccountId: string
}

export enum GenerateReconciliationsReportFieldNames {
  PERIOD = 'period',
  ACCOUNT_ID = 'bankAccountId',
}

export interface GenerateAccountingChecksReportData {
  requestAccountingVatNoteInvoiceReport: string
}

export interface AccountingChecksReportsData {
  listAccountingVatNoteInvoiceReports: Page_AccountingVatReportDTO
}

export interface DownloadAccountingChecksReportData {
  downloadAccountingVatNoteInvoiceReport: AccountingVatReportDTO
}

export interface CancelAccountingChecksReportData {
  cancelAccountingVatNoteInvoiceReport: boolean
}

export interface CancelAccountingChecksReportVariables {
  reportId: string
}
